/* ============================================================
   Offe Market - filter drawer: In stock on by default

   When a shopper starts filtering, "In stock" is ticked for them
   so the results don't fill up with sold-out products.

   WHEN IT STEPS IN: only on the first filter a shopper picks,
   i.e. when no filters are applied yet (nothing starting with
   filter. in the page address). After that it leaves them alone:
   they can untick In stock, or tick Out of stock, and it won't
   be put back. "Clear all" resets things, so the next filter
   they pick ticks In stock again.

   It never overrides a choice about availability itself: picking
   In stock or Out of stock directly is left exactly as clicked.

   HOW: the theme's facets.js waits 800ms after a change and then
   reads the whole form, so ticking the In stock box here, in the
   same moment as the shopper's click, gets it included in that
   one request. No extra page load. The listener is on document
   because the theme rebuilds the filter groups after every
   change, which would drop listeners attached to them.
   ============================================================ */

(() => {
  const AVAILABILITY = 'filter.v.availability';
  const IN_STOCK = '1';

  const hasActiveFilters = () => {
    const params = new URLSearchParams(window.location.search);
    for (const key of params.keys()) {
      if (key.startsWith('filter.')) return true;
    }
    return false;
  };

  document.addEventListener(
    'input',
    (event) => {
      const input = event.target;
      if (!(input instanceof HTMLInputElement)) return;

      const form = input.closest('#FacetFiltersForm');
      if (!form) return;

      // Only real filters, and not the availability group itself.
      if (!input.name || !input.name.startsWith('filter.')) return;
      if (input.name === AVAILABILITY) return;

      // Unticking something isn't "starting to filter".
      if (input.type === 'checkbox' && !input.checked) return;

      if (hasActiveFilters()) return;

      const boxes = form.querySelectorAll(
        `input[type="checkbox"][name="${AVAILABILITY}"]`
      );
      if (!boxes.length) return;
      if (Array.from(boxes).some((box) => box.checked)) return;

      const inStock = Array.from(boxes).find((box) => box.value === IN_STOCK);
      if (!inStock || inStock.disabled) return;

      inStock.checked = true;
      const label = form.querySelector(`label[for="${inStock.id}"]`);
      label?.setAttribute('aria-checked', 'true');
    },
    true
  );
})();
